
import { mapState } from 'vuex'

export default {
  props: ['owner'],
  computed: {
    ...mapState(['env']),
    label () {
      return this.owner.departmentName || this.owner.department
    }
  }
}
